var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "history" },
    [
      _c("div", { staticClass: "history--heading" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("event")) +
            " " +
            _vm._s(_vm.$t("split.history")) +
            " "
        ),
      ]),
      !_vm.showMore
        ? _c("EventTable", {
            staticClass: "table",
            attrs: {
              "vendor-options": _vm.vendorOptions,
              "table-name": "historyTable",
            },
          })
        : _vm._e(),
      _vm.showMore
        ? _c("EventTable", {
            staticClass: "expandedTable",
            attrs: {
              "vendor-options": _vm.vendorOptions,
              "table-name": "historyTable",
            },
          })
        : _vm._e(),
      _vm.showButton
        ? _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "buttons",
            },
            [
              _c(
                "pui-button",
                {
                  attrs: { state: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.showMoreFunction()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.buttonLabel) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }